import React from 'react';
import { DeadlineRuleType } from '@/types';
import { WeekdayRuleSectionProps } from '@/types/deadlineRule';
import { TimeSelector } from '../ui/TimeSelector';
import { DEFAULT_PICKUP_TIME_SETTINGS } from '../../utils/timePickerDefaults';

export const WeekdayRuleSection: React.FC<WeekdayRuleSectionProps> = ({
  dayOfWeek,
  dayLabel,
  dayRules,
  isEnabled,
  isLoading = false,
  onWeekdayToggle,
  onPickupToggle,
  onDeliveryToggle,
  onRuleUpdate,
}) => {
  return (
    <div className='flex flex-col gap-3 p-4 border border-gray-200 dark:border-gray-600 rounded-lg'>
      {/* 曜日ヘッダー */}
      <div className='flex items-center justify-between'>
        <label className='flex items-center min-h-[44px] touch-target'>
          <input
            type='checkbox'
            checked={isEnabled}
            aria-checked={isEnabled}
            autoFocus={
              typeof process !== 'undefined' && process.env.NODE_ENV === 'test' && dayOfWeek === 1 // DayOfWeek.MONDAY
            }
            onChange={e => onWeekdayToggle(dayOfWeek, e.target.checked)}
            disabled={isLoading}
            className='rounded border-gray-300 text-primary-600 focus:ring-green-500 min-h-[20px] min-w-[20px]'
          />
          <span className='ml-3 text-sm font-bold text-gray-900 dark:text-white'>{dayLabel}</span>
        </label>
      </div>

      {isEnabled && (
        <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 pl-8'>
          {/* 引取締切時間 */}
          <div className='space-y-3'>
            <div className='flex items-center gap-2'>
              <input
                id={`pickup-${dayOfWeek}`}
                type='checkbox'
                checked={Boolean(dayRules.pickup && !dayRules.pickup.isDeleted)}
                onChange={e => onPickupToggle(dayOfWeek, e.target.checked)}
                disabled={isLoading}
                className='rounded border-gray-300 text-primary-600 focus:ring-green-500 min-h-[16px] min-w-[16px]'
              />
              <label
                htmlFor={`pickup-${dayOfWeek}`}
                className='text-sm font-medium text-gray-900 dark:text-white'
              >
                引取締切時間
              </label>
            </div>
            {dayRules.pickup && !dayRules.pickup.isDeleted ? (
              <div className='ml-6'>
                <TimeSelector
                  label=''
                  value={dayRules.pickup.deadlineTime}
                  onChange={value => {
                    onRuleUpdate(DeadlineRuleType.PICKUP, dayOfWeek, 'deadlineTime', value);
                  }}
                  timeSettings={DEFAULT_PICKUP_TIME_SETTINGS}
                  intervalMinutes={15}
                  disabled={isLoading}
                />
              </div>
            ) : (
              <p className='text-sm text-gray-500 dark:text-gray-400 ml-6'>未設定</p>
            )}
          </div>

          {/* 搬入締切時間 */}
          <div className='space-y-3'>
            <div className='flex items-center gap-2'>
              <input
                id={`delivery-${dayOfWeek}`}
                type='checkbox'
                checked={Boolean(dayRules.delivery && !dayRules.delivery.isDeleted)}
                onChange={e => onDeliveryToggle(dayOfWeek, e.target.checked)}
                disabled={isLoading}
                className='rounded border-gray-300 text-primary-600 focus:ring-blue-500 min-h-[16px] min-w-[16px]'
              />
              <label
                htmlFor={`delivery-${dayOfWeek}`}
                className='text-sm font-medium text-gray-900 dark:text-white'
              >
                搬入締切時間
              </label>
            </div>

            {dayRules.delivery && !dayRules.delivery.isDeleted ? (
              <div className='ml-6'>
                <TimeSelector
                  label=''
                  value={dayRules.delivery.deadlineTime}
                  onChange={value => {
                    onRuleUpdate(DeadlineRuleType.DELIVERY, dayOfWeek, 'deadlineTime', value);
                  }}
                  timeSettings={DEFAULT_PICKUP_TIME_SETTINGS}
                  intervalMinutes={15}
                  disabled={isLoading}
                />
              </div>
            ) : (
              <p className='text-sm text-gray-500 dark:text-gray-400 ml-6'>未設定</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
